import React from 'react';
import 'react-toggle/style.css';
import styled from 'styled-components';

import IRhapsodyServer from 'src/ServerEntities/IRhapsodyServer';
import IRhapsodyServerPanel from 'src/ServerEntities/IRhapsodyServerPanel';
import ErrorBox from 'src/SharedComponents/ErrorBox';
import LoadingIndicator from 'src/SharedComponents/LoadingIndicator';
import { SessionContext } from 'src/Views/SessionContext';
import { getRhapsodyHeader, getRhapsodyServers } from '../ramService';
import ServerDetailsPanel from '../Components/ServeDetailsPanel';
import { ContentContainer } from '../Intersystems/IntersystemsDashboard';


const SiteContainer = styled.ul`
    margin-top: 24px;
    flex: 1 1 auto;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
    width: 1280px;
        margin-top: 24px;
    flex: 1 1 auto;
    display: flex;
`;

interface IProps {
    selectedTypes: string[],
    changeRole: boolean,
    setChangeRole: (changeRole: boolean) => void
};

const isIntersystems = (headerInfo: IRhapsodyServer[], selectedServer: number) => {
    return headerInfo && headerInfo[selectedServer] && headerInfo[selectedServer].serverType === "Ensemble"
};

const MonitorServers = (props: IProps) => {
    const { state, dispatch } = React.useContext(SessionContext);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState("");
    const [data, setData] = React.useState(undefined as unknown as IRhapsodyServer[]);
    const [serverPanels, setServerPanels] = React.useState(undefined as unknown as IRhapsodyServerPanel[])
    const headerInfo = state.headerInfo ? state.headerInfo : data;

    React.useEffect(() => {
        if (!state.headerInfo) {
            setLoading(true);
            getRhapsodyHeader(state.webToken, (serverData: IRhapsodyServer[]) => {
                setLoading(false);
                setData(serverData);
                setError("");
                loadServers();
                dispatch({ type: "setHeaderInfo", payload: serverData });
            }, (errorMessage: string) => {
                setLoading(false);
                setError(errorMessage);
            });
        }
        loadServers();
    }, [state.webToken]);

    const loadServers = () => {
        setLoading(true);
        getRhapsodyServers(state.webToken, (data: IRhapsodyServerPanel[]) => {
            setLoading(false);
            setServerPanels(data);
            setError("");
        }, (errorMessage: string) => {
            setLoading(false);
            setError(errorMessage);
        });
    };

    return <ContentContainer>
        <LoadingIndicator type="Linear" show={loading} />
        {error && <ErrorBox>{error}</ErrorBox>}
        <SiteContainer>
            {serverPanels && serverPanels.map((serverPanel: IRhapsodyServerPanel, index: number) => {
                return <ServerDetailsPanel token={state.webToken} key={`rhapsody-server-${index}-panel`} data={serverPanel} showName={true} interystems={isIntersystems(headerInfo, 0)} />
            })}
        </SiteContainer>
    </ContentContainer>;
};

export default MonitorServers;
